"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockquoteModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
/**
 * Component capable of rendering the `BlockquoteModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let BlockquoteModuleUi = class BlockquoteModuleUi extends ui_1.AbstractSimpleModuleUi {
};
BlockquoteModuleUi = __decorate([
    vue_property_decorator_1.Component({ ...ui_1.abstractSimpleModuleUiOptions, name: 'BlockquoteModuleUi' })
], BlockquoteModuleUi);
exports.BlockquoteModuleUi = BlockquoteModuleUi;
//# sourceMappingURL=Blockquote.ui.js.map